import React, { Component } from 'react';
import { polyglot } from '../../../assets/locales';
import { CalculationUtils, formatter } from '../../../utility';

class SingleRentIncreaseBreakdown extends Component {
  /**
   * @returns {html} - Generates breakdown for each year. Uses modifier variable to attach italics for year 2 and 3.
   */
  generateCalculation = (cpiPercent, year, calcYear, rent, eligibleAmount, item1, item2, item3, item4, item5) => {
    let remainingAmountText = polyglot.t('webtool3.remainingAmount');

    if (calcYear === 3) remainingAmountText = polyglot.t('step2.increaseBreakdown.remainingAmount3');

    return (
      <>
        {calcYear >= 2 ? (
          <div className={`breakdown-item`}>
            <span className={`breakdown-item-remaining`}>{formatter.toAmountDisplay(eligibleAmount)}</span>
            <span className={`breakdown-item-remaining-text`}>{polyglot.t('webtool3.previousRemainingAmount')}</span>
          </div>
        ) : null}
        <div className={`breakdown-item`}>
          <span className="breakdown-item-cost">{formatter.toAmountDisplay(rent)}</span>
          <span>{polyglot.t('webtool3.currentRent')}</span>
        </div>
        <div className={`breakdown-item`}>
          <span className="breakdown-item-cost">{formatter.toAmountDisplay(item1)}</span>
          <span>
            {polyglot.t('step2.increaseBreakdown.increaseAmount')} ({cpiPercent.toFixed(1)}%)
          </span>
        </div>
        <div className={`breakdown-item`}>
          <span className={`breakdown-item-cost`}>{formatter.toAmountDisplay(item2)}</span>
          <span>
            {polyglot.t('webtool2.eligibleAmount')}
            <a href={polyglot.t('webtool2.eligibleAmountUrl')} alt="" target="_blank" rel="noopener noreferrer">
              {polyglot.t('webtool2.eligibleAmountUrlText')}
            </a>
          </span>
        </div>
        <div className={`breakdown-item`}>
          <span className={`breakdown-item-cost`}>{formatter.toAmountDisplay(item3)}</span>
          <span>{polyglot.t('step2.increaseBreakdown.additionalIncrease')}</span>
        </div>
        <div className={`breakdown-item`}>
          <span className={`breakdown-item-total`}>{formatter.toAmountDisplay(item4)}</span>
          <span>{polyglot.t('webtool3.maximumApplied', { year: year })}</span>
        </div>
        <div className={`breakdown-item-italic`}>
          <span className={`breakdown-item-remaining-italic`}>{formatter.toAmountDisplay(item5)}</span>
          <span className={`breakdown-item-remaining-text-italic`}>{remainingAmountText}</span>
        </div>
      </>
    );
  };

  shouldComponentUpdate(nextProps) {
    if (this.props.rent !== nextProps.rent) {
      return true;
    }

    return false;
  }

  render() {
    const { cpi, rent, eligibleAmount, calcYear, displayYear, setFullRentAmount } = this.props;
    const year = typeof displayYear === 'string' ? displayYear : displayYear.getFullYear();
    const cpiPercent = Number((cpi.value / 100).toFixed(3));

    /* Calculations */
    const YA = CalculationUtils.rentIncreaseAmount(rent, cpiPercent);
    const YB = CalculationUtils.rentWithIncrease(rent, YA);
    const YC = CalculationUtils.maxAdditionalIncrease(YB, eligibleAmount);
    const YD = CalculationUtils.rentWithAllIncreases(YB, YC);
    const YF = CalculationUtils.remainingAmount(eligibleAmount, YC);

    const yearBreakdown = this.generateCalculation(cpi.value, year, calcYear, rent, eligibleAmount, YA, YB, YC, YD, YF);
    setFullRentAmount(YD);

    return (
      <div className="breakdown">
        <div className="breakdown-title"> {year} Rent Increase Calculation</div>
        {yearBreakdown}
      </div>
    );
  }
}

export default SingleRentIncreaseBreakdown;
